import { Component, inject } from '@angular/core';
import { ViewModelService } from '../shared/view-model.service';

@Component({
   // tslint:disable-next-line:component-selector
   selector: 'app-identification-error-summary',
   standalone: true,
   templateUrl: './error-summary.component.html',
})
export class ErrorSummaryComponent {
   public vm = inject(ViewModelService);
}
